export default __webpack_public_path__ + "static/media/Q1_0_resized.a8f9f72f.jpg";